import { useEffect, useRef } from "react";
import { CalendarDays } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { BRAND } from "@/lib/constants";

const CALENDLY_URL = "https://calendly.com/eilon-stemmer/30min";

export default function BookDemoTab() {
  const containerRef = useRef(null);

  useEffect(() => {
    const CSS_ID = "calendly-widget-css";
    if (!document.getElementById(CSS_ID)) {
      const link = document.createElement("link");
      link.id = CSS_ID;
      link.rel = "stylesheet";
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(link);
    }

    const SCRIPT_ID = "calendly-widget-js";
    const init = () => {
      if (window.Calendly && containerRef.current) {
        containerRef.current.innerHTML = "";
        window.Calendly.initInlineWidget({
          url: CALENDLY_URL,
          parentElement: containerRef.current,
        });
      }
    };

    let script = document.getElementById(SCRIPT_ID);
    if (window.Calendly) {
      init();
    } else if (script) {
      script.addEventListener("load", init);
    } else {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.async = true;
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.addEventListener("load", init);
      document.body.appendChild(script);
    }

    const node = containerRef.current;
    return () => {
      if (node) node.innerHTML = "";
    };
  }, []);

  return (
    <div className="w-full space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <div
              className="w-7 h-7 rounded-md flex items-center justify-center shrink-0"
              style={{ backgroundColor: BRAND.soft }}
            >
              <CalendarDays className="w-4 h-4" style={{ color: BRAND.text }} />
            </div>
            Book a Demo
          </CardTitle>
          <CardDescription>
            Pick a time that suits you — it books straight onto Eilon's calendar and you'll
            get a confirmation email.
          </CardDescription>
        </CardHeader>

        <CardContent>
          {/* No "calendly-inline-widget" class: that triggers Calendly's auto-init,
              which reads a null data-url and crashes. We init programmatically below. */}
          <div
            ref={containerRef}
            style={{ minWidth: "320px", height: "680px" }}
          />
          <p className="text-xs text-gray-400 mt-3">
            Scheduling is handled by{" "}
            <a
              href="https://calendly.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Calendly
            </a>
            .
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
